<script setup lang="ts">
  // import Footer from './components/footer/Footer.vue';
</script>
<template>
  <!-- <router-view /> -->
  <div class="p-d-flex p-flex-column" style="min-height: 100vh;">
    <!-- Conteúdo das páginas -->
    <div class="p-flex-grow-1">
      <router-view />
      <!-- <Footer /> -->
    </div>

  </div>
</template>